// no baseURI

// object to store loaded and loading chunks
// undefined = chunk not loaded, null = chunk preloaded/prefetched
// [resolve, reject, Promise] = chunk loading, 0 = chunk loaded
var installedChunks = {
	"/scripts/app": 0,
	"styles/app": 0,
	"styles/blocks/core-buttons": 0,
	"styles/blocks/core-button": 0,
	"styles/editor-overrides": 0,
	"styles/editor": 0,
	"components/youtube-embed/index": 0,
	"blocks/share/style": 0,
	"blocks/media-card/style": 0,
	"blocks/media-card/_mixins": 0,
	"blocks/lead-form/style": 0,
	"blocks/content-grid/style": 0,
	"blocks/card-grid/style": 0,
	"blocks/breadcrumb/style": 0,
	"blocks/article-grid/style": 0,
	"blocks/accordion/editor": 0,
	"blocks/accordion-item/style": 0,
	"styles/blocks/gravityforms-form": 0,
	"styles/blocks/gds-article-list": 0,
	"styles/blocks/core-table": 0,
	"styles/blocks/core-social-links": 0,
	"styles/blocks/core-social-link": 0,
	"styles/blocks/core-separator": 0,
	"styles/blocks/core-search": 0,
	"styles/blocks/core-quote": 0,
	"styles/blocks/core-pullquote": 0,
	"styles/blocks/core-post-date": 0,
	"styles/blocks/core-paragraph": 0,
	"styles/blocks/core-media-text": 0,
	"styles/blocks/core-list": 0,
	"styles/blocks/core-image": 0,
	"styles/blocks/core-heading": 0,
	"styles/blocks/core-group": 0,
	"styles/blocks/core-gallery": 0,
	"styles/blocks/core-embed": 0,
	"styles/blocks/core-cover": 0,
	"styles/blocks/core-columns": 0,
	"styles/blocks/core-column": 0,
	"styles/blocks/core-code": 0
};

__webpack_require__.f.j = (chunkId, promises) => {
		// JSONP chunk loading for javascript
		var installedChunkData = __webpack_require__.o(installedChunks, chunkId) ? installedChunks[chunkId] : undefined;
		if(installedChunkData !== 0) { // 0 means "already installed".

			// a Promise means "currently loading".
			if(installedChunkData) {
				promises.push(installedChunkData[2]);
			} else {
				if(/^(\/scripts\/app|resources_components_youtube\-embed_index_js)$/.test(chunkId)) {
					// setup Promise in chunk cache
					var promise = new Promise((resolve, reject) => (installedChunkData = installedChunks[chunkId] = [resolve, reject]));
					promises.push(installedChunkData[2] = promise);

					// start chunk loading
					var url = __webpack_require__.p + __webpack_require__.u(chunkId);
					// create error before stack unwound to get useful stacktrace later
					var error = new Error();
					var loadingEnded = (event) => {
						if(__webpack_require__.o(installedChunks, chunkId)) {
							installedChunkData = installedChunks[chunkId];
							if(installedChunkData !== 0) installedChunks[chunkId] = undefined;
							if(installedChunkData) {
								var errorType = event && (event.type === 'load' ? 'missing' : event.type);
								var realSrc = event && event.target && event.target.src;
								error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
								error.name = 'ChunkLoadError';
								error.type = errorType;
								error.request = realSrc;
								installedChunkData[1](error);
							}
						}
					};
					__webpack_require__.l(url, loadingEnded, "chunk-" + chunkId, chunkId);
				} else installedChunks[chunkId] = 0;
			}
		}
};

// no prefetching

// no preloaded

// no HMR

// no HMR manifest

__webpack_require__.O.j = (chunkId) => (installedChunks[chunkId] === 0);

// install a JSONP callback for chunk loading
var webpackJsonpCallback = (parentChunkLoadingFunction, data) => {
	var [chunkIds, moreModules, runtime] = data;
	// add "moreModules" to the modules object,
	// then flag all "chunkIds" as loaded and fire callback
	var moduleId, chunkId, i = 0;
	if(chunkIds.some((id) => (installedChunks[id] !== 0))) {
		for(moduleId in moreModules) {
			if(__webpack_require__.o(moreModules, moduleId)) {
				__webpack_require__.m[moduleId] = moreModules[moduleId];
			}
		}
		if(runtime) var result = runtime(__webpack_require__);
	}
	if(parentChunkLoadingFunction) parentChunkLoadingFunction(data);
	for(;i < chunkIds.length; i++) {
		chunkId = chunkIds[i];
		if(__webpack_require__.o(installedChunks, chunkId) && installedChunks[chunkId]) {
			installedChunks[chunkId][0]();
		}
		installedChunks[chunkId] = 0;
	}
	return __webpack_require__.O(result);
}

var chunkLoadingGlobal = globalThis["webpackChunk"] = globalThis["webpackChunk"] || [];
chunkLoadingGlobal.forEach(webpackJsonpCallback.bind(null, 0));
chunkLoadingGlobal.push = webpackJsonpCallback.bind(null, chunkLoadingGlobal.push.bind(chunkLoadingGlobal));